<template>
  <section>
    <m-table-list ref="tableList" :fetch-list-func="fetchListFunc" :search-form.sync="filters">
      <template v-slot:search-items>
        <m-search-panel @searchBoxChange="handleSearch" isShowOpenButton @keyup.enter.native="handleSearch()">
          <div slot="title">快速筛选</div>
          <div class="filters">
            <div class="query-item-all">
              <div class="filter-item">
                <div class="demonstration">标签组名称</div>
                <el-input v-model.trim="filters.labelGroupName" clearable placeholder="标签组名称"></el-input>
              </div>
              <div class="filter-item">
                <div class="demonstration">标签名称</div>
                <el-input v-model.trim="filters.labelName" clearable placeholder="标签名称"></el-input>
              </div>
            </div>
            <div class="filter-item buttons">
              <el-button type="primary" size="samll" class="query-btn" @click="handleSearch">查询</el-button>
              <el-button type="primary" size="samll" plain @click="handleClearSearchForm">重置</el-button>
            </div>
          </div>
        </m-search-panel>
      </template>
      <template v-slot:page-title>
        <div class="page-tabe-title">
          <div class="right">
            <span class="line"></span>
            <div>数据列表</div>
          </div>
          <div class="left">
            <el-button type="primary" size="small" class="add-btn"
                       @click="$router.push({name: 'privilege.tags.details'})">+添加
            </el-button>
          </div>
        </div>
      </template>
      <template v-slot:table-columns>
        <el-table-column label="标签组名称" prop="labelGroupName" show-overflow-tooltip></el-table-column>
        <el-table-column label="标签项" prop="labelName" show-overflow-tooltip></el-table-column>
        <el-table-column label="选择模式" prop="pattern"
                         :formatter="(row)=>row.pattern==='RADIO'?'单选':'多选'"></el-table-column>
        <el-table-column label="是否启用" prop="status"
                         :formatter="(row)=>row.status==='Enable'?'启用':'禁用'"></el-table-column>
        <el-table-column label="备注" prop="remark" show-overflow-tooltip></el-table-column>
        <el-table-column label="创建时间" prop="created"
                         :formatter="(row)=>new Date(+new Date(row.created) + 8 * 3600 * 1000).toISOString().replace(/T/g, ' ')
        .replace(/\.[\d]{3}Z/, '')"></el-table-column>
        <el-table-column label="操作" width="140px">
          <template slot-scope="{row}">
            <el-button
                @click="$router.push({name: 'privilege.tags.details', query: { id: row.id }})"
                type="text" size="small">编辑
            </el-button>
            <el-button @click="deleteRow(row.id)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </template>
    </m-table-list>
  </section>
</template>

<script>
import api from "plus/api";
import tableList from "components/tableList";

export default {
  name: "privilege.tags.list",
  data() {
    return {
      filters: {
        labelGroupName: '',
        labelName: ''
      },
      time: "",
      roleOptions: [],
    };
  },
  components: {
    "m-table-list": tableList,
  },
  methods: {
    fetchListFunc: api.manage.getTagsList,
    handleSearch() {
      this.$refs.tableList.handleSearch();
    },
    handleClearSearchForm() {
      this.$refs.tableList.resetSearchForm();
    },
    deleteRow(id) {
      this.$confirm("是否删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        api.manage.deleteTags({id: id}).then(() => {
          this.$message.success("删除成功");
          this.$refs.tableList.getMainData();
        });
      });
    },
  },
};
</script>
